// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active[data-v-52484ea8]{color:#ff6700;font-weight:600}", "",{"version":3,"sources":["webpack://./resources/js/components/Global/Navbar/TheNavBarMobileItem.vue"],"names":[],"mappings":"AACA,yBACE,aAAA,CACA,eAAF","sourcesContent":["\n.active {\n  color: #ff6700;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
